import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Const, ResourceType } from '../../../../core/helpers/Const';
import { NavigationService } from '../../../../service/services/misc/navigation/navigation.service';
import { HeaderTitleService } from '../../../../service/services/misc/header-title/header-title.service';
import { BreadcrumbModel } from '../../../../core/models/misc/breadcrumb.model';
import { Utils } from '../../../../core/helpers/Utils';
import { ResourcePageComponent } from '../../../../core/components/abstract/resource-page/resource-page.component';
import { DialogService } from '../../../../service/services/misc/dialog/dialog.service';
import { ResourceDataService } from '../../../../service/services/rest/resource-data/resource-data.service';
import {TablePersonalizationDefinitions} from '../../../../core/helpers/TablePersonalizationDefinitions';
import {EventService} from "../../../../service/services/misc/event/event.service";
import {UisService} from "../../../../service/services/misc/uis/uis.service";
import { OrganizationModel } from "../../../../core/models/resources/organization.model";
import {
    OrganizationHierarchyStoreService
} from "../../../../service/store/organization-hierarchy-store/organization-hierarchy-store.service";
import {SwaService} from "../../../../service/services/misc/swa/swa.service";
import {ResourceNotificationService} from "../../../../service/services/misc/fcl/resource-notification.service";
import {SavedFilterViewsService} from "../../../../service/services/misc/saved-filter-views/saved-filter-views.service";

@Component({
    selector: 'app-organizations',
    templateUrl: './organizations.component.html',
    styleUrls: ['./organizations.component.scss'],
    standalone: false
})
export class OrganizationsComponent extends ResourcePageComponent implements OnInit, OnDestroy {
    ResourceType = ResourceType;
    Utils = Utils;
    hasError = false;
    selectedProject: string;
    Object = Object;
    isPaginatedView = false;

    get currentTableKey(): string {
        return this.advancedSearchOpen
            ? TablePersonalizationDefinitions.AdvancedSearchTable.key
            : TablePersonalizationDefinitions.ResourcesTable.key;
    }

    constructor(
    private organizationHierarchyStore: OrganizationHierarchyStoreService,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private headerTitleService: HeaderTitleService,
		private dialogService: DialogService,
		protected override _headerTitleService: HeaderTitleService,
		private resourceDataService: ResourceDataService,
      protected override cdRef: ChangeDetectorRef,
      protected override eventService: EventService,
        protected override uisService: UisService,
        protected override swaService: SwaService,
        protected override resourceNotificationService: ResourceNotificationService,
        savedFilterViewsService: SavedFilterViewsService

    ) {
        super(organizationHierarchyStore, navigationService, dialogService, _headerTitleService, resourceDataService, cdRef, eventService, uisService, swaService, resourceNotificationService, savedFilterViewsService);
        this.searchTerm = '';
    }

    override async ngOnInit() {
        this.headerTitleService.setTitle(await this.generatePageTitle('', new OrganizationModel()));

        this.subscriptions.push(this.subscribeToUrlChange());
        if (Utils.hasFeatureFlag(Const.FEATURE_ADVANCED_SEARCH)) {
            await this.loadDiscoveryApiResources();
        }

    }

    subscribeToUrlChange() {
        return this.route.paramMap.subscribe((paramMap) => {
            this.currentResource = ResourceType.ORGANIZATION;
            const projectName = paramMap.get(Const.ROUTE_PARAMETERS.PROJECT);
            if (projectName) {
                this.selectedProject = projectName;
            }

            // Close advanced search when navigating to a different location
            // This ensures the path column is removed if it was added by advanced search
            if (this.advancedSearchOpen) {
                this.advancedSearchOpen = false;
            }
        });
    }

    getProjectUrl(project: string) {
        return this.navigationService.getNavigationUrl(['project', project, 'organizations']);
    }

    isProjectVisible() {
        return this.selectedProject === Const.ALL_PROJECTS_PARAM;
    }

    override async generatePageTitle(path: string,  org: OrganizationModel) {
        let breadcrumbs: BreadcrumbModel[] = [
            {
                text: $localize`:XTIT|Header of the Organizations page@@pageHeaders.organizations:Organizations`,
                url: '',
                index: 0,
                name: '',
                path: '',
                loading: false,
                type: null,
                siblings: [],
                isOpen: false,
                totalCount: 0,
                continueToken: ""
            },
        ];
        return breadcrumbs;
    }
}
